export default "__VITE_ASSET__CbMNc_xd__"